<template>
  <div class="cashback-page" ref="cashbackPage">
    <!-- 上部分 - 标题 -->
    <div class="title-section">
      <h1 class="main-title">GIFT CARD</h1>
    </div>

    <!-- PC端布局 -->
    <div class="content-wrapper pc-layout">
      <div class="background-image"></div>
      <div class="container">
        <div class="content-section">
          <!-- 左侧文案 -->
          <div class="left-content">
            <h2 :class="['animate-up', { 'start-animation': isVisible }]">
              <!-- Make Every Penny Count! -->
            </h2>
            <p
              :class="[
                'animate-up animation-delay-1',
                { 'start-animation': isVisible },
              ]"
            >
              The right to freely select desired goods or services enables the
              recipient to enjoy shopping pleasures at will and effortlessly
              embark on a satisfying consumption journey at any time. Truly, in
              every occasion and every moment, it can deliver sincere emotions
              and infinite value in a considerate manner
            </p>
            <button
              :class="[
                'more-btn animate-up animation-delay-2',
                { 'start-animation': isVisible },
              ]"
              @click="handleMoreClick"
            >
              More
            </button>
          </div>

          <!-- 右侧图片 -->
          <div class="right-content">
            <div class="images-container">
              <img
                v-for="(image, index) in images"
                :key="index"
                :class="[
                  'slide-in-right',
                  { 'start-animation': isVisible },
                  `delay-${index}`,
                ]"
                :src="image"
                alt="Gift Card"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 移动端布局 -->
    <div class="mobile-layout">
      <!-- 中间部分 - 带背景的图片 -->
      <div class="mobile-image-section">
        <div class="right-content">
          <div class="images-container">
            <img
              v-for="(image, index) in images"
              :key="index"
              :class="[
                'slide-in-right',
                { 'start-animation': isVisible },
                `delay-${index}`,
              ]"
              :src="image"
              alt="Gift Card"
            />
          </div>
        </div>
      </div>

      <!-- 下部分 - 文案 -->
      <div class="mobile-content">
        <h2 :class="['animate-up', { 'start-animation': isVisible }]">
          <!-- Make Every Penny Count! -->
        </h2>
        <p
          :class="[
            'animate-up animation-delay-1',
            { 'start-animation': isVisible },
          ]"
        >
          The right to freely select desired goods or services enables the
          recipient to enjoy shopping pleasures at will and effortlessly embark
          on a satisfying consumption journey at any time. Truly, in every
          occasion and every moment, it can deliver sincere emotions and
          infinite value in a considerate manner
        </p>
        <button
          :class="[
            'more-btn animate-up animation-delay-2',
            { 'start-animation': isVisible },
          ]"
          @click="handleMoreClick"
        >
          More
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CashbackPage",
  data() {
    return {
      isVisible: false,
      observer: null,
      images: [
        require("@/assets/imgsnew/page5-2.svg"),
        require("@/assets/imgsnew/page5-3.svg"),
        require("@/assets/imgsnew/page5-4.svg"),
      ],
    };
  },
  mounted() {
    this.setupIntersectionObserver();
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    handleMoreClick() {
      // this.$router.push("/giftCard");
      window.location.href = "/giftCard";
    },
    setupIntersectionObserver() {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.isVisible = true;
              // 重置动画状态，以便下次滚动时重新触发
              setTimeout(() => {
                if (!entry.isIntersecting) {
                  this.isVisible = false;
                }
              }, 100);
            } else {
              this.isVisible = false;
            }
          });
        },
        {
          threshold: 0.2, // 当20%的内容可见时触发
        }
      );

      this.observer.observe(this.$refs.cashbackPage);
    },
  },
};
</script>

<style scoped>
.cashback-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
}

.content-wrapper {
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  width: 100vw;
  background-image: url("@/assets/imgsnew/page5-1.svg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 600px;
  display: flex;
  align-items: center;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.content-section {
  position: relative;
  display: flex;
  align-items: center;
  gap: 80px;
  padding: 80px 0;
  width: 100%;
}

.title-section {
  margin-bottom: 60px;
}

.main-title {
  font-family: MiSans-DemiBold;
  font-size: 40px;
  font-weight: 600;
  line-height: 60px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}

.left-content {
  flex: 0.8;
  color: white;
  padding-left: 40px;
}

.left-content h2 {
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 20px;
  color: white;
}

.left-content p {
  font-size: 18px;
  line-height: 1.6;
  margin-bottom: 30px;
  color: white;
  max-width: 460px;
}

.more-btn {
  background-color: #0047cc;
  color: white;
  padding: 12px 40px;
  border: none;
  border-radius: 50px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.more-btn:hover {
  background-color: #003399;
}

.right-content {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.images-container {
  display: flex;
  gap: 20px;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.right-content img {
  width: auto;
  height: auto;
  max-width: 250px;
}

@media (max-width: 768px) {
  .content-section {
    flex-direction: column;
    padding: 60px 0;
    gap: 40px;
  }

  .left-content {
    padding-left: 0;
  }

  .right-content img {
    max-width: 360px;
  }

  .main-title {
    font-size: 40px;
    line-height: 44px;
  }

  .left-content,
  .right-content {
    text-align: center;
  }

  .content-wrapper {
    margin-left: -20px;
    margin-right: -20px;
    width: calc(100% + 40px);
  }
}

/* 从下往上的动画 */
.animate-up {
  opacity: 0;
  transform: translateY(60px);
  will-change: transform, opacity;
  transition: none;
}

.animate-up.start-animation {
  animation: slideUp 2.2s ease-out forwards;
}

/* 调整动画延迟时间 */
.animation-delay-1 {
  animation-delay: 0.8s;
}

.animation-delay-2 {
  animation-delay: 1.6s;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(60px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 从右侧滑入的动画 */
.slide-in-right {
  opacity: 0;
  transform: translateX(100vw);
  will-change: transform, opacity;
  transition: none;
}

.slide-in-right.start-animation {
  animation: slideInRight 2.8s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

@keyframes slideInRight {
  0% {
    opacity: 0;
    transform: translateX(100vw);
  }
  40% {
    opacity: 1;
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

/* 移动端适配 */
@media (max-width: 768px) {
  .slide-in-right {
    animation-duration: 2s;
    animation-delay: 1.2s;
  }

  .animate-up {
    transform: translateY(40px);
  }
}

.mobile-layout {
  display: none;
}

@media (max-width: 768px) {
  .pc-layout {
    display: none;
  }

  .mobile-layout {
    display: block;
  }

  .cashback-page {
    padding: 20px 0;
  }

  /* 中间图片部分样式 */
  .mobile-image-section {
    position: relative;
    width: 100vw;
    margin-left: -20px;
    margin-right: -20px;
    background-image: url("@/assets/imgsnew/page5-1.svg");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    padding: 40px 0;
  }

  .mobile-image-section .right-content {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 0;
  }

  .mobile-image-section img {
    max-width: 280px;
    margin: 0 auto;
  }

  /* 下部分文案样式 */
  .mobile-content {
    padding: 40px 20px;
    text-align: center;
    color: #333;
  }

  .mobile-content h2 {
    font-size: 28px;
    font-weight: 600;
    margin-bottom: 20px;
    color: #333;
  }

  .mobile-content p {
    font-size: 16px;
    line-height: 1.5;
    margin-bottom: 24px;
    color: #333;
  }

  .mobile-content .more-btn {
    padding: 10px 32px;
    font-size: 15px;
  }

  /* 标题部分调整 */
  .title-section {
    margin-bottom: 30px;
  }

  .main-title {
    font-size: 32px;
    line-height: 40px;
  }

  .images-container {
    gap: 10px;
  }

  .right-content img {
    max-width: 100px;
  }

  .mobile-image-section .images-container {
    padding: 0 10px;
  }
}

/* 添加延迟动画类 */
.delay-0 {
  animation-delay: 0.4s !important;
}

.delay-1 {
  animation-delay: 0.8s !important;
}

.delay-2 {
  animation-delay: 1.2s !important;
}
</style>
